import React from 'react';

import { Loadable } from '../../../components/navigation/Loadable';
import { allowedUserType, USER_TYPES } from '../../../utils/constants';
import { withPrivateRoute } from '../withPrivateRoute';

const { PATIENT } = USER_TYPES;

/**
 * @satisfies {ExtendedRouteObject}
 */
export const purchaseRoutes = {
  name: 'Purchase',
  path: 'purchase',
  type: 'item',
  ...withPrivateRoute(Loadable(React.lazy(() => import('../../../components/prescriptions/Prescriptions'))), {
    userCanAccess: ({ userType }) => allowedUserType([PATIENT], userType),
  }),
};
